export const TECHNOLOGY_INNOVATION_AWARD_SLUG = "2026-technology-innovation-award";

export const TECHNOLOGY_INNOVATION_AWARD_PATH = `/blog/${TECHNOLOGY_INNOVATION_AWARD_SLUG}`;

// Embargo: The Aesthetic Awards win is announced Tuesday 29 September 2026 at 9:00 a.m.
// Eastern. Until then the post answers 404 and the announcement bar stays hidden. Also
// the date shown on the post and in its Article JSON-LD.
export const TECHNOLOGY_INNOVATION_AWARD_PUBLISHED_AT = new Date("2026-09-29T13:00:00Z");

export const isTechnologyInnovationAwardPublished = (now: Date): boolean =>
  now.getTime() >= TECHNOLOGY_INNOVATION_AWARD_PUBLISHED_AT.getTime();
